import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.supplementSearch;
export const supplementSearchSelector = (state: RootState) => getState(state).data?.tableData || [];
export const supplementSearchPaginationSelector = (state: RootState) =>
  getState(state).data?.pagination;
export const supplementSearchIsLoadingSelector = (state: RootState) => getState(state).isLoading;
